import { Controller } from "@hotwired/stimulus"

// Warns when leaving a page while a planning generation is running server-side.
// The Sidekiq job continues regardless; this sets user expectations.
export default class extends Controller {
  static values = {
    message: String
  }

  connect() {
    this.boundBeforeUnload = this.handleBeforeUnload.bind(this)
    this.boundTurboBeforeVisit = this.handleTurboBeforeVisit.bind(this)

    window.addEventListener("beforeunload", this.boundBeforeUnload)
    document.addEventListener("turbo:before-visit", this.boundTurboBeforeVisit)
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.boundBeforeUnload)
    document.removeEventListener("turbo:before-visit", this.boundTurboBeforeVisit)
  }

  handleBeforeUnload(event) {
    if (!this.messageValue) return

    event.preventDefault()
    event.returnValue = this.messageValue
    return this.messageValue
  }

  handleTurboBeforeVisit(event) {
    if (!this.messageValue) return

    // Turbo page refreshes (the job's completion broadcast_refresh_to) are
    // same-URL visits — guarding them pops the confirm out of nowhere the
    // moment generation finishes, and Cancel blocks the page update.
    if (event.detail.url === window.location.href) return

    if (!window.confirm(this.messageValue)) {
      event.preventDefault()
    }
  }
}
